import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { FormMultiselect } from 'cng-common/features/form'
import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { Flex } from 'core-components/library/flex'
import { Static } from 'core-components/types'
import { Crud } from 'core/types'
import { selectMdfActivities } from 'partner360/features/mdfActivities/model'

import { MDF_ACTIVITIES_TRANSLATION_KEYS } from '../../configs/translations'
import { useMdfDashboardFiltersForm } from '../../hooks/useMdfDashboardFiltersForm'
import { filtersInitialData, MDF_DASHBOARD_FILTERS_FORM } from '../views/mdfDashboard/config'

import { MdfBusinessPrioritiesFilter } from './components'
import { transformActivitiesFieldToOptions } from './helpers/transformActivitiesFieldToOptions'

import styles from './MdfDashboardFiltersPopup.module.scss'

const KEYS = MDF_ACTIVITIES_TRANSLATION_KEYS

interface IMdfDashboardFiltersPopup {
  onClose: () => void
}

export const MdfDashboardFiltersPopup = ({ onClose }: IMdfDashboardFiltersPopup) => {
  const activities = useSelector(selectMdfActivities)
  const { resetFormData } = useMdfDashboardFiltersForm()

  const strategicInitiativesSource = useMemo(() => {
    const data = transformActivitiesFieldToOptions(
      activities,
      (activity) => activity.strategicInitiatives
    )
    return new Crud({
      fetcher: new Static(data),
      keyField: 'key',
      defaultPaging: { page: 0, pageSize: data.length },
    })
  }, [activities])

  const timeframesSource = useMemo(() => {
    const data = transformActivitiesFieldToOptions(activities, (activity) => activity.timeframe)
    return new Crud({
      fetcher: new Static(data),
      keyField: 'key',
      defaultPaging: { page: 0, pageSize: data.length },
    })
  }, [activities])

  const onResetFilters = useCallback(() => {
    resetFormData()
    onClose()
  }, [onClose, resetFormData])

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.field}>
          <Translation text={KEYS.dashboard.filters.strategicInitiative} />

          <FormMultiselect
            defaultValue={filtersInitialData.strategicInitiatives}
            field={'strategicInitiatives'}
            formKey={MDF_DASHBOARD_FILTERS_FORM}
            source={strategicInitiativesSource}
            caption={'label'}
            isStatic
          />
        </div>

        <MdfBusinessPrioritiesFilter />

        <div className={styles.field}>
          <Translation text={KEYS.dashboard.filters.timeframe} />

          <FormMultiselect
            defaultValue={filtersInitialData.timeframes}
            field={'timeframes'}
            formKey={MDF_DASHBOARD_FILTERS_FORM}
            source={timeframesSource}
            caption={'label'}
            isStatic
          />
        </div>
      </div>

      <Flex className={styles.btnWrapper} justifyContent={'flex-end'}>
        <Button color={'danger'} onClick={onResetFilters}>
          <Translation text={KEYS.dashboard.filters.resetFilters} />
        </Button>
        <Button color={'grey'} onClick={onClose}>
          <Translation text={KEYS.dashboard.filters.close} />
        </Button>
      </Flex>
    </div>
  )
}
